import { Layout } from 'antd';
import Color from 'color';
import React, { FC } from 'react';
import styled from 'styled-components';
import { useAccount } from 'hooks/use-account';

const { Footer: AntFooter } = Layout;

const StyledFooter = styled(AntFooter)<{ sideNavBg: string }>`
  align-items: center;
  color: var(--side-nav-text);
  display: flex;
  text-align: center;
  background: ${({ sideNavBg }) => sideNavBg};
  z-index: 2;
`;

export const Footer: FC = ({ children }) => {
  const { metaData } = useAccount();
  const defaultNavBg = '#161616';
  const sideNavColour = metaData.theme?.sideNavBg ?? defaultNavBg;

  return (
    <StyledFooter sideNavBg={Color(sideNavColour).darken(0.6).hex()}>
      {children}
    </StyledFooter>
  );
};
